import * as React from "react";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import {
  gridClasses,
  DataGrid,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarQuickFilter,
  GridToolbarExport,
  trTR
} from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import { alpha, styled } from '@mui/material/styles';
import { makeStyles } from "@mui/styles";
import { Button } from "@mui/material/";
import { setAllListForExport, setIsDailyReportExport } from "features/commonSlice";
import * as XLSX from "xlsx";
import { createSvgIcon } from '@mui/material/utils';
import VisibilityIcon from '@mui/icons-material/Visibility';
import moment from 'moment';

const ODD_OPACITY = 0.2;

const StripedDataGrid = styled(DataGrid)(({ theme }) => ({
  [`& .${gridClasses.row}.even`]: {
    backgroundColor: theme.palette.grey[200],
    '&:hover, &.Mui-hovered': {
      backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
      '@media (hover: none)': {
        backgroundColor: 'transparent',
      },
    },
    '&.Mui-selected': {
      backgroundColor: alpha(
        theme.palette.primary.main,
        ODD_OPACITY + theme.palette.action.selectedOpacity,
      ),
      '&:hover, &.Mui-hovered': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          ODD_OPACITY +
          theme.palette.action.selectedOpacity +
          theme.palette.action.hoverOpacity,
        ),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: alpha(
            theme.palette.primary.main,
            ODD_OPACITY + theme.palette.action.selectedOpacity,
          ),
        },
      },
    },
  },
  [`& .${gridClasses.row}.odd`]: {
    backgroundColor: theme.palette.grey,
    '&:hover, &.Mui-hovered': {
      backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
      '@media (hover: none)': {
        backgroundColor: 'transparent',
      },
    },
    '&.Mui-selected': {
      backgroundColor: alpha(
        theme.palette.primary.main,
        ODD_OPACITY + theme.palette.action.selectedOpacity,
      ),
      '&:hover, &.Mui-hovered': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          ODD_OPACITY +
          theme.palette.action.selectedOpacity +
          theme.palette.action.hoverOpacity,
        ),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: alpha(
            theme.palette.primary.main,
            ODD_OPACITY + theme.palette.action.selectedOpacity,
          ),
        },
      },
    },
  },
}));

export default function CustomExport(props) {
  const [pageSize, setPageSize] = React.useState(10);
  const [overflow, setOverflow] = React.useState("visible");
  const [currentexportFileName, setCurrentexportFileName] = React.useState(``);

  const [showContentTitle, setShowContentTitle] = React.useState("İçerik Göster");
  const [contentFieldName, setContentFieldName] = React.useState(undefined);

  const [columns, setColumns] = useState(props.columns);

  const [quickFilterValue, setQuickFilterValue] = React.useState('');

  const useStyles = makeStyles({
    root: {
      "& .MuiDataGrid-cell, & .MuiDataGrid-columnHeaderTitle, & .MuiDataGrid-cellContent": {
        textOverflow: "clip",
        overflow: overflow,
        whiteSpace: "initial",
        lineHeight: "normal",
        height: "auto",
        marginTop: "10px",
        border: "none",
        outline: "none !important"
      },
    }

  });

  const classes = useStyles();

  useEffect(() => {
    if (props.pageSize !== undefined)
      setPageSize(props.pageSize);

    if (props.overflow !== undefined)
      setOverflow(props.overflow);

    if (props.contentFieldName !== undefined)
      setContentFieldName(props.contentFieldName);

  }, []);

  useEffect(() => {
    if (props.queryIdFromUrl !== undefined) {
      setQuickFilterValue(props.queryIdFromUrl);
    }
  }, [props.queryIdFromUrl]);

  useEffect(() => {

    if (props.columns.length > 0)
      setColumns(props.columns);
  }, [props.columns]);

  const ExportIcon = createSvgIcon(
    <path d="M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2z" />,
    'SaveAlt',
  );

  const buttonBaseProps = {
    color: 'primary',
    size: 'small',
    startIcon: <ExportIcon />,
  };

  const buttonBasePropsVisibility = {
    color: 'primary',
    size: 'small',
    startIcon: <VisibilityIcon />,
  };

  const dispatch = useDispatch();

  const downloadExcel = () => {
    if ((props.exportFileName || "").includes("GunlukRapor")) {
      window.dispatchEvent(new Event("backdropOpenStartEvent"));
      dispatch(setIsDailyReportExport(true));
      return;
    }

    window.dispatchEvent(new Event("backdropOpenStartEvent"));

    const rowsToUse = ((props.exportFileName || "").includes("RaporDosyaIndirmeListesi"))
      ? (props.rowsExport ?? props.rows ?? [])
      : (props.rows ?? []);

    const colsToUse = ((props.exportFileName || "").includes("RaporDosyaIndirmeListesi"))
      ? (props.columnsExport ?? props.columns ?? [])
      : (props.columns ?? []);

    const arrayObject = rowsToUse.map((row) => {
      const obj = {};

      colsToUse.forEach((col) => {
        if (col.disableExport) return;

        let value = row?.[col.field];

        if (
          value &&
          (col.field === "insertDate" ||
            col.field === "createDate" ||
            col.field === "creationDate" ||
            col.headerName === "Oluşma Tarihi")
        ) {
          value = moment(value).format("DD.MM.YYYY HH:mm:ss");
        }

        obj[col.headerName] = value;
      });

      return obj;
    });

    const worksheet = XLSX.utils.json_to_sheet(arrayObject);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "WebRapor");
    XLSX.writeFile(workbook, (props.exportFileName || "Export") + ".xlsx");

    window.dispatchEvent(new Event("backdropOpenEndEvent"));
  };


  const toggleColumnVisibility = (field) => {

    let buffercolumn = [];
    columns.map((column) => {
      if (column.field === field) {
        setShowContentTitle(!column.hide ? "İçerik Göster" : "İçerik Gizle");
      }

      buffercolumn.push(column.field === field ? { ...column, hide: !column.hide } : column)
    }
    )

    setColumns(buffercolumn);
  };

  const CustomToolbar = props => (
    <GridToolbarContainer {...props}>
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      {/* <GridToolbarExport csvOptions={{
        fileName: props.exportfilename,   
        utf8WithBom: true,
        allColumns: true,
      }}
        printOptions={{ disableToolbarButton: true }} /> */}
      <Button
        {...buttonBaseProps}
        onClick={downloadExcel}
      >
        Dışa Aktar
      </Button>
      {contentFieldName !== undefined ?
        <Button
          {...buttonBasePropsVisibility}
          onClick={() => toggleColumnVisibility(contentFieldName)}
        >
          {showContentTitle}

        </Button>
        : ""}
      <GridToolbarQuickFilter value={quickFilterValue} onChange={(event) => {
        setQuickFilterValue(event.target.value);
      }} />
    </GridToolbarContainer>
  );

  return (
    <Box
      sx={{ width: "100%" }}
    >
      <StripedDataGrid
        className={classes.root}
        localeText={trTR.components.MuiDataGrid.defaultProps.localeText}
        autoHeight
        getRowHeight={() => 'auto'}
        sx={{
          fontSize: 12,
        }}
        pageSize={pageSize}
        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
        rowsPerPageOptions={[10, 15, 20, 50, 75, 100]}
        pagination
        isRowSelectable={(params) => false}
        rows={props.rows}
        columns={columns}
        components={{ Toolbar: CustomToolbar }}
        componentsProps={{ toolbar: { exportfilename: props.exportFileName } }}
        getCellClassName={params => `cellstyle`}
        getRowClassName={(params) =>
          params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
        }
      // filterModel={{
      //   items: [
      //     { columnField: 'id', operatorValue: 'contains', value: quickFilterValue },
      //   ],
      // }}
      />

    </Box>

  );
}
